module.exports = __webpack_public_path__ + "img/zm.03b542a4.svg";